<template>
  <div class="BWSelect">
    <div>
      <Select
        :columnsTerm="valuesMarriageStatus"
        :placeholder="marriagePlaceholder"
        :label="marriageLabel"
        v-model="marriage"
      ></Select>
    </div>
    <div>
      <Select
        :columnsTerm="valuesEmerRelation"
        :label="relationshipWithLabel"
        :placeholder="relationshipWithPlaceholder"
        v-model="relationshipWith"
      ></Select>
    </div>
  </div>
</template>

<script>
import fieldConfig from '@/configs/fileds';
import Select from './Select.vue';

export default {
  name: 'BWSelect',
  props: ['label', 'placeholder', 'columnsTerm', 'value'],
  components: {
    Select,
  },
  data() {
    return {
      showTermPicker: false,
      showTermPickerRelationshipWith: false,
      marriage: '',
      relationshipWith: '',
      marriageLabel: '',
      relationshipWithLabel: '',
      marriagePlaceholder: '',
      relationshipWithPlaceholder: '',
      valuesMarriageStatus: [],
      valuesEmerRelation: [],
    };
  },
  methods: {},
  inject: ['root'],
  watch: {
    label: {
      handler(val) {
        const splitArr = val.split('/');
        this.marriageLabel = fieldConfig[splitArr[0]].label;
        this.relationshipWithLabel = fieldConfig[splitArr[1]].label;
        this.marriagePlaceholder = fieldConfig[splitArr[0]].placeholder;
        this.relationshipWithPlaceholder = fieldConfig[splitArr[1]].placeholder;
      },
      immediate: true,
    },
    columnsTerm: {
      handler(val) {
        const { valuesEmerRelation, valuesMarriageStatus } = val;
        this.valuesEmerRelation = valuesEmerRelation;
        this.columns = valuesEmerRelation;
        this.valuesMarriageStatus = valuesMarriageStatus;
      },
      immediate: true,
    },
    value: {
      handler(val) {
        console.log(val);
      },
      immediate: true,
    },
    relationshipWith: {
      handler(val) {
        this.root.getRelationshipWith(val);
      },
    },
    marriage: {
      handler(value) {
        this.root.getMarriage(value);
      },
    },
  },
};
</script>
<style scoped>

.BWSelect >>>.van-field__label {
  text-align: left;
  width: 80px;
}
.van-picker__cancel,
.van-picker__confirm {
  color: #ff6538;
}
</style>
